define('mediaGallery/mediaGallery',[
],
    function () {

        const mediaGallerySelector = ".media-gallery";
        const swiperSelector = "div[id^='media_gallery_swiper_']";
        const thumbsSelector = "div[id^='media_gallery_thumbs_']";

        // ZOOM & PINCH MEDIA GALLERY
        function initZoomAndPinch(slidesSelector) {
            slidesSelector = slidesSelector || '.media-gallery .main .swiper-slide';
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                setTimeout(function () {
                    var divs = document.querySelectorAll(slidesSelector + ' .swiper-image-container img').forEach(function (el) {
                        new PinchZoom(el, {
                            tapZoomFactor: 3,
                            minZoom: 1,
                            maxZoom: 3
                        });
                    });
                }, 250);
            }
            else {
                // Thumbnail hovers
                $(".thumb-slide").off('click').on('click', function () {
                        var parent = $(this).parent();
                        var slideIndex = parent.children().index($(this)[0]);
                        var swiperContainer = $(this).closest(mediaGallerySelector).find(swiperSelector);
                        var swiper = swiperContainer[0].swiper;
                        setTimeout(function () {
                            swiper.slideTo(slideIndex);
                        }, 250);
                });
            }
        }

        function monitorIframe() {
            // SET INTERVAL TO DETECT IFRAME CLICK
            var monitor = setInterval(function(){
                var elem = document.activeElement;
                if(elem && elem.tagName == 'IFRAME'){
                    elem.blur();
                    $('.media-gallery').addClass('video-playing');
                    clearInterval(monitor);
                }
            }, 100);
        }

        (function loadDynamicIframe() {
            // ADD DEFAULT YOUTUBE IMAGE TO IFRAME
            $('.media-gallery .video-embed').each(function(){
                var y = $(this).attr('data-thumb');
                $(this).css('background-image','url('+ y + ')');
            });
            // REPLACE DEFAULT YOUTUBE IMAGE WITH YOUTUBE
            $('.media-gallery .video_wrapper .icon-play').on('click',function(){
                var b = $(this).next().attr('data-src');
                $(this).next().attr('src',b);
                $(this).remove();
            });
            $('.media-gallery .video_wrapper .play-icon').on('click', function () {
                var b = $(this).next().attr('data-src');
                $(this).next().attr('src', b);
                $(this).remove();
            });
            monitorIframe();
        }());

        function position(galleryNumber, slideId) {
            var swiperContainer = $("#media_gallery_swiper_" + galleryNumber);
            if (swiperContainer.length) {
                var swiper = swiperContainer[0].swiper;
                if (swiper) {
                    var slideIndex = $(swiperContainer).find(".swiper-slide[data-slide-id=" + slideId + "]").index(".swiper-slide");
                    if (slideIndex >= 0) {
                        swiper.slideTo(slideIndex, 0);
                        displayCaptionForCurrentSlide(swiper);
                    }
                }
            }
        }

        function displayVariantImages(galleryNumber, variantImageId, additionalVariantImages) {

            if (!window.mediaGalleryData || !window.mediaGalleryData.variantImages) return;  // there's no mediaGalleryData to work with

            var swiperContainerSelector = "#media_gallery_swiper_" + galleryNumber;
            var variantImageSlideSelector = swiperContainerSelector + " .swiper-slide[data-slide-type=VariantImage]";

            var swiperContainer = $(swiperContainerSelector);
            if (!swiperContainer.length) return; // no swiper container - nothing to do
            var swiper = swiperContainer[0].swiper;
            if (!swiper) return; // no swiper initializaed - nothing to do

            var swiperChanged = false;
            // first, remove currently displayed variant images
            $(variantImageSlideSelector).each(function (index, slideElement) {
                var slideIndex = $(slideElement).index(".swiper-slide");
                swiper.removeSlide(slideIndex);
                swiper.thumbs.swiper.removeSlide(slideIndex);
                swiperChanged = true;
            });

            // then, add images given as parameters
            var imagesToAdd = variantImageId ? [variantImageId].concat(additionalVariantImages) : additionalVariantImages;
            if (imagesToAdd.length) {
                var slideCssClass = $(swiperContainer).data("slideCssClass");
                var thumbnailSlideCssClass = $(swiperContainer).data("thumbnailSlideCssClass");

                var slidesToAdd = [];
                var thumbnailsToAdd = [];
                imagesToAdd.forEach(function (imageId) {
                    var variantImage = mediaGalleryData.variantImages[imageId];
                    //checking if variant image exist (if image is unpublished it will be undefined and it will raise error in javascript)
                    if (variantImage) {
                        slidesToAdd.push(getSlideHtml(slideCssClass, imageId, variantImage.caption, variantImage.url, variantImage.alt));
                        thumbnailsToAdd.push(getThumbnailSlideHtml(thumbnailSlideCssClass, variantImage.thumbnailUrl, variantImage.alt));
                    }
                });

                swiper.prependSlide(slidesToAdd.reverse());
                swiper.thumbs.swiper.prependSlide(thumbnailsToAdd.reverse());

                swiperChanged = true;
            }

            if (swiperChanged) {
                swiper.slideTo(0, 0);
                // do the required initializations for newly added slides
                initZoomAndPinch(variantImageSlideSelector);
                $(variantImageSlideSelector).off('click').on('click', displayGalleryPopup);
                dispatchResizeEvent();
                displayCaptionForCurrentSlide(swiper);
            }
        }

        function getSlideHtml(cssClass, slideId, slideCaption, imageUrl, alt) {
            return '<div class="swiper-slide main-slide ' + cssClass + '"' +
                'data-slide-id="' + slideId + '"' +
                'data-slide-type="VariantImage"' +
                'data-slide-caption="' + slideCaption + '">' +
                '<div class="swiper-zoom-container spinner-background">' +
                '<a class="easyzoom" href="' + imageUrl + '" onclick="return false;">' +
                '<img alt="' + alt + '" data-src="' + imageUrl + '" class="swiper-lazy"/>' +
                '</a>' +
                '<div class="swiper-lazy-preloader"></div>' +
                '</div>' +
                '</div>';
        }

        function getThumbnailSlideHtml(cssClass, imageUrl, alt) {
            return '<div class="swiper-slide thumb-slide ' + cssClass + '">' +
                '<div class="swiper-zoom-container spinner-background">' +
                '<img src="' + imageUrl + '" alt="' + alt + '"/>' +
                '</div>' +
                '</div>';
        }

        function displayCaptionForCurrentSlide(swiper) {
            var slide = swiper.slides[swiper.realIndex];

            // Taking the caption for variant images from the Javascript object, and for other images from their data-slide-caption attribute.
            // (This is because double quote characters are causing problems in variant image slide, which are generated dynamically in runtime.)
            var imageId = $(slide).data("slideId");
            var variantImage = mediaGalleryData.variantImages ? mediaGalleryData.variantImages[imageId] : null;
            var captionHtmlEncoded = variantImage ? variantImage.caption : $(slide).data("slideCaption");
            // caption string is HTML encoded (so it doesn't mess up Javascript object or data attribute), now we have to decode it back
            var textArea = document.createElement('textarea');
            textArea.innerHTML = captionHtmlEncoded;
            var caption = textArea.value;

            $(slide).closest(mediaGallerySelector).find(".caption").empty().html(caption);
            if($('.media-gallery').hasClass('video-playing')) {
                $('.media-gallery').removeClass('video-playing'); 
                $('.media-gallery .video-embed').each(function(){
                    var el_src = $(this).attr("src");
                    $(this).attr("src",el_src);
                });
                monitorIframe();  
            }
        }

        function displayGalleryPopup(event) {
            if (!(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))) {
                setTimeout(function () {
                    $('.easyzoom').EasyZoomMagnifierReset();

                    if (!$(".modal-gallery").hasClass("open-modal")) {
                        $('.modal-gallery').addClass('open-modal');
                    }
                    dispatchResizeEvent();
                }, 250);
            }
        }

        function closeGalleryPopup(event) {
            //e.preventDefault();
            var data = $(".swiper-container.main").data();

            $(".swiper-lazy.swiper-lazy-loaded").css("transform", "translate3d(0px, 0px, 0px) scale(1)");
            $(".swiper-zoom-container").css("transform", "translate3d(0px, 0px, 0px)");

            $('.modal-gallery').removeClass('open-modal');
            $('.easyzoom').EasyZoomMagnifier();

            dispatchResizeEvent();
        }

        function dispatchResizeEvent() {
            var event;
            if (typeof (Event) === 'function') {
                event = new Event('resize');
            } else {
                event = document.createEvent('Event');
                event.initEvent('resize', false, false);
            }

            window.dispatchEvent(event);
        }

        return {
            position: position,
            displayVariantImages: displayVariantImages,
            displayCaptionForCurrentSlide: displayCaptionForCurrentSlide,
            mediaGallerySelector: mediaGallerySelector,
            swiperSelector: swiperSelector,
            thumbsSelector: thumbsSelector,
            displayGalleryPopup: displayGalleryPopup,
            closeGalleryPopup: closeGalleryPopup,
            initZoomAndPinch: initZoomAndPinch
        };
    });

